<template>
  <div class="mainpage">
    <div class="retutnbt" @click="toback">
      <el-image class="elimage" :src="returnImg" />
      返回
    </div>
    <div class="head">
      <div class="head-title">实习详情</div>
    </div>
    <div class="line"></div>
    <div class="maincontain">
      <div class="t-contain">
        <div class="t-contain-left">
          <el-image class="elimage" :src="defaultImage" />
        </div>
        <div class="t-contain-right">
          <div class="h-title">{{ infoData.practice_plan_name }}</div>
          <div class="h-title3">
            <div class="item_c">{{ infoData.type | typeFilter }}</div>
            <div class="h-title3_1">
              <span class="txt">实习时间：</span>
              <span class="txt-time">
                {{ infoData.start_date | dataformat }}
                <span v-if="infoData.start_date && infoData.end_date">~</span>
                {{ infoData.end_date | dataformat }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="f-contain">
        <div class="f-title">
          <el-image class="icon" :src="shipinformation" />
          基本信息
        </div>
        <div class="contain">
          <div class="item_c">
            <div class="company">实践类型： </div>{{ infoData.config_type_name }}
          </div>
          <div class="item_c">
            <div class="company">指导教师：</div> {{ infoData.teacher_names }}
          </div>
          <div class="item_c">
            <div class="company">实习介绍:</div>
            <div class="txt">{{ infoData.remark }}</div>
          </div>
        </div>
      </div>

      <!-- <div class="g-contain">
        <div class="f-title">实习介绍</div>
        <div class="contain">
          <div class="item_c">{{ infoData.remark }}</div>
        </div>
      </div> -->
      <div class="h-contain">
        <div class="f-title">
          <el-image class="icon" :src="shiptask" />
          实习任务
        </div>
        <div class="contain" v-for="(item, index) in settingList" :key="index">
          <div class="item_c" v-if="item.student_task.indexOf('1') != -1">
            <el-image class="icon" :src="checkIn" />
            <div class="text_t">
              签到： 每天签到
              <span class="txt">{{ item.student_sign_in_count }}</span>
              次
            </div>
          </div>
          <div class="item_c" v-if="item.teacher_task == '1'">
            <el-image class="icon" :src="checkIn" />
            <div class="text_t">教师签到：</div>
            <div class="text_t2">
              每天签到
              <span class="txt">{{ item.teacher_sign_in_count }}</span>
              次
            </div>
          </div>
          <div class="item_c" v-if="item.student_task.indexOf('2') != -1">
            <div class="text_t">日报：</div>
            <div class="text_t2">
              每{{ item.daily_report_list[0] }}天 至少提交{{
                item.daily_report_list[1]
              }}篇，每篇不少于{{ item.daily_report_list[2] }}字，提交总篇数不少于{{ item.daily_report_list[3] }}篇
            </div>
          </div>
          <div class="item_c" v-if="item.student_task.indexOf('3') != -1">
            <div class="text_t">周报：</div>
            <div class="text_t2">
              每{{ item.weekly_report_list[0] }}周 至少提交{{
                item.weekly_report_list[1]
              }}篇，每篇不少于{{ item.weekly_report_list[2] }}字， 提交总篇数不少于{{ item.weekly_report_list[3] }}篇
            </div>
          </div>
          <div class="item_c" v-if="item.student_task.indexOf('4') != -1">
            <div class="text_t">月报：</div>
            <div class="text_t2">
              每{{ item.monthly_report_list[0] }}月 至少提交{{
                item.monthly_report_list[1]
              }}篇，每篇不少于{{ item.monthly_report_list[2] }}字， 提交总篇数不少于{{ item.monthly_report_list[3] }}篇
            </div>
          </div>
          <div class="item_c" v-if="item.student_task.indexOf('5') != -1">
            <div class="text_t">实习报告： 提交时间：
              {{ item.report_commit_start_date | dataformat }}
              <span v-if="
                item.report_commit_start_date && item.report_commit_end_date
              ">~</span>
              {{ item.report_commit_end_date | dataformat }}
            </div>
          </div>
        </div>
      </div>
      <div class="j-contain">
        <div class="f-title">
          <el-image class="icon" :src="shiparrange" />
          实习报告
        </div>
        <div class="contain" v-for="(item, index) in settingList" :key="index">
          <div class="t_text">{{ item.url_name }}</div>
          <div class="image_con" @click="download(item.url, item.url_name)" v-if="item.url_name != ''">
            <el-image class="elimage" :src="icon5" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { getsetplaninfo } from "@/api/practiceresult"

const typeMap = ["全部", "自主报名", "集中安排"]

export default {
  name: "mainpage",
  components: {},
  data() {
    return {
      settingList: [], // 实习规则
      infoData: "",
      defaultImage: require("@/assets/coursedetails/center/defaultImage.png"),
      icon4: require("@/assets/查看.png"),
      icon5: require("@/assets/下载.png"),
      shipinformation: require("@/assets/coursedetails/center/icon/shipinformation.png"),
      shiptask: require("@/assets/coursedetails/center/icon/shiptask.png"),
      shiparrange: require("@/assets/coursedetails/center/icon/shiparrange.png"),
      dailyReport: require("@/assets/coursedetails/center/icon/dailyReport.png"),
      checkIn: require("@/assets/coursedetails/center/icon/checkIn.png"),
      returnImg: require("@/assets/coursedetails/center/return.png"), // 返回
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD")
      // return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss");
    },
    typeFilter(val) {
      return typeMap[val]
    },
  },
  computed: {
    practice_plan_id() {
      return this.$route.query.practice_plan_id
    },
    student_id() {
      return this.$route.query.student_id
    },
  },
  created() {
    this.getInfo() //获取实习计划设置详情
  },
  methods: {
    //获取实习计划详情
    getInfo() {
      let params = {
        practice_plan_id: this.practice_plan_id,
        student_id: this.student_id,
      }
      getsetplaninfo(params)
        .then((response) => {
          if (response.code === 0) {
            this.infoData = response.data
            this.settingList = response.data.settingInfo.map((item) => {
              let obj = {
                apply_type: item.apply_type,
                daily_report_list: item.daily_report
                  ? item.daily_report.split(",")
                  : [],
                weekly_report_list: item.weekly_report
                  ? item.weekly_report.split(",")
                  : [],
                monthly_report_list: item.monthly_report
                  ? item.monthly_report.split(",")
                  : [],
                report_commit_start_date: item.report_commit_start_date,
                report_commit_end_date: item.report_commit_end_date,
                student_task: item.student_task,
                student_sign_in_count: item.student_sign_in_count,
                teacher_task: item.teacher_task,
                teacher_sign_in_count: item.teacher_sign_in_count,
                url: item.url,
                url_name: item.url_name,
                evaluation_commit_end_date: item.evaluation_commit_end_date,
                evaluation_commit_start_date: item.evaluation_commit_start_date,
                practice_evaluation_template_url:
                  item.practice_evaluation_template_url,
                practice_report_template_url: item.practice_report_template_url,
              }
              return obj
            })
          }
        })
        .catch((error) => {
          //console.log(error);
        })
    },
    // 返回
    toback() {
      this.$router.push({
        path: "/home/myInternship",
        // query: {
        //   id: 6,
        //   componentId: "Myinternship",
        // },
      })
    },
    // 下载
    download(url, name) {
      var ele = document.createElement("a") // 创建下载链接
      ele.download = name //设置下载的名称
      ele.style.display = "none" // 隐藏的可下载链接
      ele.href = url
      // 绑定点击时间
      document.body.appendChild(ele)
      ele.click()
      // 然后移除
      document.body.removeChild(ele)
    },
  },
};
</script>
<style scoped lang="scss">
.mainpage {
  min-height: calc(100vh - 240px);

  .retutnbt {
    display: flex;
    align-items: center;
    margin-top: 30px;
    font-weight: 400;
    font-size: 18px;
    color: rgba(26, 62, 137, 0.99);
    cursor: pointer;

    .elimage {
      margin-right: 10px;

    }
  }

  .head {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    padding-top: 10px;
    background: rgba($color: #fff, $alpha: 0.5);
    border-radius: 26px 26px 0px 0px;
    border: 1px solid #FFFFFF;
    border-bottom: none;

    .head-title {
      font-size: 20px;
      font-weight: 400;
      color: #3d84ff;
      user-select: none;
      white-space: nowrap;
    }

  }

  .line {
    // border-bottom: 2px solid #cccccc;
  }

  .maincontain {
    border-radius: 4px;
    padding-bottom: 20px;

    .t-contain {
      min-height: 70px;
      background: rgba($color: #fff, $alpha: 0.5);
      box-sizing: border-box;
      padding: 20px;
      margin-bottom: 10px;
      border-radius: 0px 0px 26px 26px;
      border: 1px solid #FFFFFF;
      border-top: none;
      display: flex;
      align-items: center;

      .h-title {
        font-size: 25px;
        font-weight: 400;
        color: #222222;
        margin-bottom: 20px;
      }

      .h-title3 {
        .item_c {
          width: 100px;
          height: 28px;
          background: #4F9DF9;
          border-radius: 0px 12px 12px 12px;
          opacity: 0.7;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.99);
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .h-title3_1 {
          .txt {
            font-weight: 500;
            font-size: 18px;
            color: #4F9DF9;
          }

          .txt-time {
            font-weight: 500;
            font-size: 20px;
            color: #262E38;
          }
        }
      }

      .t-contain-right {
        margin-left: 30px;
      }
    }

    .tip_con {
      margin-bottom: 10px;
      height: 32px;
      background-color: rgba(230, 247, 255, 1);

      border: 1px solid rgba(145, 213, 255, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 20px;
      padding-right: 20px;

      .icon_con {
        display: flex;
        justify-content: center;
        align-items: center;

        .icon_text {
          background: #0773fc;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          color: white;
          text-align: center;
        }

        .icon_name {
          margin-left: 6px;
          font-size: 16px;
          font-weight: 400;
          color: #666;
        }
      }

      .look_bt {
        font-size: 16px;
        font-weight: 400;
        color: #666;
        user-select: none;
        cursor: pointer;
      }
    }

    .f-contain {
      margin-top: 20px;

      background: rgba($color: #fff, $alpha: 0.5);
      box-sizing: border-box;
      padding: 20px;
      border-radius: 26px;
      border: 1px solid #FFFFFF;

      .f-title {
        font-weight: 400;
        font-size: 24px;
        color: #262E38;
        line-height: 26px;
        display: flex;
        align-items: center;

        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }

      .contain {
        margin-top: 30px;
        // display: flex;
        // justify-content: flex-start;
        // align-items: center;
        // flex-wrap: wrap;

        .item_c {
          font-weight: 400;
          font-size: 18px;
          color: #262E38;
          line-height: 16px;
          margin-bottom: 30px;
          display: flex;

          .company {
            width: 6%;
            align-items: center;
          }

          .txt {
            font-weight: 400;
            font-size: 16px;
            color: #262E38;
            line-height: 30px;
            background: #FFFFFF;
            border-radius: 10px;
            border: 1px solid #DCE6F6;
            opacity: 0.8;
            padding: 10px;
            width: 100%;
          }
        }
      }
    }

    .g-contain {
      margin-top: 20px;

      background: rgba($color: #fff, $alpha: 0.5);
      box-sizing: border-box;
      padding: 20px;
      border-radius: 26px;
      border: 1px solid #FFFFFF;

      .f-title {
        font-weight: 400;
        font-size: 24px;
        color: #262E38;
        line-height: 26px;
        display: flex;
        align-items: center;

        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }

      .contain {
        margin-top: 10px;

        .item_t {
          margin-top: 10px;
          flex-basis: 33%;
          font-size: 18px;
          font-weight: 400;
          color: #666666;
        }

        .item_c {
          margin-top: 10px;
          flex-basis: 33%;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    .h-contain {
      margin-top: 20px;

      background: rgba($color: #fff, $alpha: 0.5);
      box-sizing: border-box;
      padding: 20px;
      border-radius: 26px;
      border: 1px solid #FFFFFF;

      .f-title {
        font-weight: 400;
        font-size: 24px;
        color: #262E38;
        line-height: 26px;
        display: flex;
        align-items: center;

        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }

      .contain {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        .item_c {
          margin-top: 10px;
          flex-basis: 50%;
          background: #FFFFFF;
          border-radius: 10px;
          border: 1px solid #DCE6F6;
          opacity: 0.8;
          height: 50px;
          display: flex;
          align-items: center;
          padding-left: 10px;

          .icon {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }

          .text_t {
            font-size: 18px;
            font-weight: 400;
            color: #666666;

            .txt {
              padding: 5px;
              color: #FF9517;
            }
          }

          .text_t2 {
            margin-top: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }

    .j-contain {
      margin-top: 20px;

      background: rgba($color: #fff, $alpha: 0.5);
      box-sizing: border-box;
      padding: 20px;
      border-radius: 26px;
      border: 1px solid #FFFFFF;


      .f-title {
        font-weight: 400;
        font-size: 24px;
        color: #262E38;
        line-height: 26px;
        display: flex;
        align-items: center;

        .icon {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }

      .contain {
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .t_text {
          font-size: 16px;
          font-weight: 400;
          color: #0773fc;
          cursor: pointer;
        }

        .image_con {
          margin-left: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .elimage {
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .mainpage {
    min-height: calc(100vh - 240px);

    .head {
      margin-top: 66px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      padding-left: 20px;
      padding-top: 10px;
      background: #ffffff;

      .head-title {
        font-size: 20px;
        font-weight: 400;
        color: #3d84ff;
        user-select: none;
        white-space: nowrap;
      }

      .retutnbt {
        margin-right: 10px;
        width: 64px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #3d84ff;
        border-radius: 4px;
        color: white;
        user-select: none;
        cursor: pointer;
        font-size: 14px;
      }
    }

    .line {
      border-bottom: 2px solid #cccccc;
    }

    .maincontain {
      border-radius: 4px;
      padding-bottom: 20px;

      .t-contain {
        min-height: 70px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;
        margin-bottom: 10px;

        .h-title {
          font-size: 25px;
          font-weight: 400;
          color: #222222;
        }
      }

      .tip_con {
        margin-bottom: 10px;
        height: 32px;
        background-color: rgba(230, 247, 255, 1);

        border: 1px solid rgba(145, 213, 255, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;
        padding-right: 20px;

        .icon_con {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon_text {
            background: #0773fc;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            color: white;
            text-align: center;
          }

          .icon_name {
            margin-left: 6px;
            font-size: 16px;
            font-weight: 400;
            color: #666;
          }
        }

        .look_bt {
          font-size: 16px;
          font-weight: 400;
          color: #666;
          user-select: none;
          cursor: pointer;
        }
      }

      .f-contain {
        margin-top: 20px;

        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;

        .f-title {
          font-weight: 400;
          font-size: 24px;
          color: #262E38;
          line-height: 26px;
          display: flex;
          align-items: center;
        }

        .contain {
          margin-top: 15px;

          // display: flex;
          // justify-content: flex-start;
          // align-items: center;
          // flex-wrap: wrap;
          .item_c {
            margin-top: 15px;
            flex-basis: 33%;
            font-size: 18px;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .g-contain {
        margin-top: 20px;

        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;

        .f-title {
          font-weight: 400;
          font-size: 24px;
          color: #262E38;
          line-height: 26px;
          display: flex;
          align-items: center;
        }

        .contain {
          margin-top: 10px;

          .item_t {
            margin-top: 10px;
            flex-basis: 33%;
            font-size: 18px;
            font-weight: 400;
            color: #666666;
          }

          .item_c {
            margin-top: 10px;
            flex-basis: 33%;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
          }
        }
      }

      .h-contain {
        margin-top: 20px;

        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;

        .f-title {
          font-weight: 400;
          font-size: 24px;
          color: #262E38;
          line-height: 26px;
          display: flex;
          align-items: center;
        }

        .contain {
          margin-top: 15px;

          // display: flex;
          // justify-content: space-between;
          // align-items: center;
          // flex-wrap: wrap;
          .item_c {
            margin-top: 15px;
            flex-basis: 50%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;

            .text_t {
              font-size: 18px;
              font-weight: 400;
              color: #666666;
            }

            .text_t2 {
              margin-top: 6px;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }

      .j-contain {
        margin-top: 20px;

        background: #ffffff;
        box-sizing: border-box;
        padding: 20px;

        .f-title {
          font-weight: 400;
          font-size: 24px;
          color: #262E38;
          line-height: 26px;
          display: flex;
          align-items: center;
        }

        .contain {
          margin-top: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .t_text {
            font-size: 16px;
            font-weight: 400;
            color: #0773fc;
            cursor: pointer;
          }

          .image_con {
            margin-left: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .elimage {
              margin-left: 4px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}
</style>
